
export enum SoundNames {
    big_win = "big_win",
    big_win_coins_loop = "big_win_coins_loop",
    big_win_fireworks = "big_win_fireworks",
    big_win_outro = "big_win_outro",
    button = "button",
    exit = "exit",
    game_menu_close = "game_menu_close",
    level1 = "level1",
    level10 = "level10",
    level11 = "level11",
    level12 = "level12",
    level13 = "level13",
    level14 = "level14",
    level2 = "level2",
    level3 = "level3",
    level4 = "level4",
    level5 = "level5",
    level6 = "level6",
    level7 = "level7",
    level8 = "level8",
    level9 = "level9",
    multiplier_marker = "multiplier_marker",
    reel_spin3 = "reel_spin3",
    reel_stop1 = "reel_stop1",
    reel_stop2 = "reel_stop2",
    reel_stop3 = "reel_stop3",
    reel_stop4 = "reel_stop4",
    spin_button = "spin_button",
    universal_symbol_win = "universal_symbol_win",
    volume_button = "volume_button",
    wild_marker1 = "wild_marker1",
    wild_marker2 = "wild_marker2",
    wild_marker3 = "wild_marker3"
}
